import script from "./SectionTypeSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./SectionTypeSelector.vue?vue&type=script&lang=ts&setup=true"

import "./SectionTypeSelector.vue?vue&type=style&index=0&id=1bc8ef66&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bc8ef66"]])

export default __exports__